let activeCloseFn = null;

export const claimActive = (closeFn) => {
  if (activeCloseFn && activeCloseFn !== closeFn) {
    const prev = activeCloseFn;
    activeCloseFn = closeFn;
    prev();
    return;
  }
  activeCloseFn = closeFn;
};

export const releaseActive = (closeFn) => {
  if (activeCloseFn === closeFn) activeCloseFn = null;
};
